// ACTIONS
export const UPLOAD_FILE = 'client/files/UPLOAD_FILE'
export const REMOVE_FILE = 'client/files/REMOVE_FILE'

// ACTION CREATORS
export const uploadFile = file => ({
  type: UPLOAD_FILE,
  payload: { file },
})

export const removeFile = id => ({
  type: REMOVE_FILE,
  payload: { id },
})

// REDUCERS
const initialState = {
  error: '',
  loading: false,
}

const filesReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    default:
      return state
  }
}

export default filesReducer
